module.exports = __webpack_public_path__ + "static/media/logo.2b18e963.jpg";